import { ACCOUNT_CHANGE_EVENT_NAME } from "../../../../javascript/utils";

interface Props {
  componentSize: string;
  containerElement: Element;
}

interface Response {
  body: string;
}

const init = async (props: Props) => {
  if (!props.componentSize && props.containerElement) throw new Error('AboutArticle: props missing');

  render(props);
  window.addEventListener(ACCOUNT_CHANGE_EVENT_NAME, () => render(props));
}

const render = async (props: Props) => {
  const response = await fetch('/api/full/get_about_article_dynamic_content?' + new URLSearchParams({
    component_size: props.componentSize,
  }));

  if (response.ok) {
    const json = await response.json() as Response;
    const element = props.containerElement.querySelector('.about-article-bottom-content');
    element.innerHTML = json.body;
  } else {
    throw new Error("AboutArticle: something went wrong when fetching dynamic content");
  }
}

export const AboutArticle = {
  init,
};
